"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseKey"));

var _initFetch = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("initFetch");

var Fetch = /*#__PURE__*/function () {
  function Fetch(options) {
    (0, _classCallCheck2["default"])(this, Fetch);
    Object.defineProperty(this, _initFetch, {
      value: _initFetch2
    });
    this.options = {};
    this.options = options;
  }

  (0, _createClass2["default"])(Fetch, [{
    key: "post",
    value: function post(path, body) {
      return (0, _classPrivateFieldLooseBase2["default"])(this, _initFetch)[_initFetch]('POST', path, body);
    }
  }]);
  return Fetch;
}();

function _initFetch2(method, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _this$options = this.options,
      baseURL = _this$options.baseURL,
      headers = _this$options.headers;
  return fetch(baseURL + path, {
    method: method,
    headers: (0, _extends2["default"])({}, headers, {
      'Content-Type': 'application/json'
    }),
    body: JSON.stringify(body),
    keepalive: true
  });
}

var _default = Fetch;
exports["default"] = _default;